<template>
    <div v-if="form && model">
        <rkm-area no-margin-top title="Filtros" type="fieldset">
            <rkm-form
                ref="Form"
                show-legend
                >
                <rkm-row>
                    <rkm-col cols="5">
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :start-validations="{ required: true }"
                            :end-validations="{ required: true }"
                            range
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            label="Veículo"
                            :options="form.veiculos"
                            v-model="model.veiculo"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Todos"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            label="Status"
                            :options="form.status"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="search"
                            color="primary"
                            >Buscar</rkm-button
                        >

                        <rkm-button :label="false" @click="reset"
                            >Limpar</rkm-button
                        >
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area no-margin-top title="Resultado">
            <template v-slot:trailing>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                no-footer-sorting
            >
                <template v-slot:cell(jan)="{ item }">
                    {{ item.totalJaneiro }}
                </template>
                <template v-slot:cell(fev)="{ item }">
                    {{ item.totalFevereiro }}
                </template>
                <template v-slot:cell(mar)="{ item }">
                    {{ item.totalMarco }}
                </template>
                <template v-slot:cell(abr)="{ item }">
                    {{ item.totalAbril }}
                </template>
                <template v-slot:cell(mai)="{ item }">
                    {{ item.totalMaio }}
                </template>
                <template v-slot:cell(jun)="{ item }">
                    {{ item.totalJunho }}
                </template>
                <template v-slot:cell(jul)="{ item }">
                    {{ item.totalJulho }}
                </template>
                <template v-slot:cell(ago)="{ item }">
                    {{ item.totalAgosto }}
                </template>
                <template v-slot:cell(set)="{ item }">
                    {{ item.totalSetembro }}
                </template>
                <template v-slot:cell(out)="{ item }">
                    {{ item.totalOutubro }}
                </template>
                <template v-slot:cell(nov)="{ item }">
                    {{ item.totalNovembro }}
                </template>
                <template v-slot:cell(dez)="{ item }">
                    {{ item.totalDezembro }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Veiculos"
            no-margin-top
            v-if="veiculos.length"
        >
            <rkm-table
                :fields="fields"
                :items="veiculos"
                no-footer-sorting
                hide-filters
            >
                <template v-slot:cell(municipio)>
                    TODOS
                </template>
                <template v-slot:cell(jan)="{ item }">
                    {{ item.totalJaneiro }}
                </template>
                <template v-slot:cell(fev)="{ item }">
                    {{ item.totalFevereiro }}
                </template>
                <template v-slot:cell(mar)="{ item }">
                    {{ item.totalMarco }}
                </template>
                <template v-slot:cell(abr)="{ item }">
                    {{ item.totalAbril }}
                </template>
                <template v-slot:cell(mai)="{ item }">
                    {{ item.totalMaio }}
                </template>
                <template v-slot:cell(jun)="{ item }">
                    {{ item.totalJunho }}
                </template>
                <template v-slot:cell(jul)="{ item }">
                    {{ item.totalJulho }}
                </template>
                <template v-slot:cell(ago)="{ item }">
                    {{ item.totalAgosto }}
                </template>
                <template v-slot:cell(set)="{ item }">
                    {{ item.totalSetembro }}
                </template>
                <template v-slot:cell(out)="{ item }">
                    {{ item.totalOutubro }}
                </template>
                <template v-slot:cell(nov)="{ item }">
                    {{ item.totalNovembro }}
                </template>
                <template v-slot:cell(dez)="{ item }">
                    {{ item.totalDezembro }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="totais.length"
        >
            <rkm-row>
                <rkm-col cols="2" v-for="item in totais" :key="item.mes">
                    {{ enums.mesesAno[item.mes] }}
                    <rkm-alert color="secondary">
                        <strong>
                            {{ item.total }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="2">
                    Total
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totais.reduce((acc, cur) => {
                                return cur.total + acc
                            }, 0) }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error, data, object, stringCase, file } from "@/mixins";

import { mapActions } from "vuex";

import moment from "moment";

import mesesAno from '@/enums/geral/mesesAno'

export default {
    watch: {
        "model.periodo.start": function () {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.getVeiculos();
            }
        },
        "model.periodo.end": function () {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.getVeiculos();
            }
        },
    },
    computed: {
        minDate() {
            return this.model.periodo.start ? moment(this.model.periodo.start).format('YYYY-MM-DD') : ''
        },
        maxDate() {
            return this.model.periodo.start ? moment(this.model.periodo.start).add(1, 'y').format('YYYY-MM-DD') : ''
        },
        optionalColumns() {
            return this.columns.filter((c) => !(c.fixed || false));
        },
        fields() {
            let meses = []
            if(this.model.periodo.start && this.model.periodo.end) {
                let mesInicial = moment(this.model.periodo.start).month() + 1
                let mesFinal = moment(this.model.periodo.end).month() + 1
                if(mesInicial <= 1 && mesFinal >= 1) {
                    meses = meses.concat({
                        key: "jan",
                        label: "JAN",
                        fixed: true,
                    })
                }
                if(mesInicial <= 2 && mesFinal >= 2) {
                    meses = meses.concat({
                        key: "fev",
                        label: "FEV",
                        fixed: true,
                    })
                }
                if(mesInicial <= 3 && mesFinal >= 3) {
                    meses = meses.concat({
                        key: "mar",
                        label: "MAR",
                        fixed: true,
                    })
                }
                if(mesInicial <= 4 && mesFinal >= 4) {
                    meses = meses.concat({
                        key: "abr",
                        label: "ABR",
                        fixed: true,
                    })
                }
                if(mesInicial <= 5 && mesFinal >= 5) {
                    meses = meses.concat({
                        key: "mai",
                        label: "MAI",
                        fixed: true,
                    })
                }
                if(mesInicial <= 6 && mesFinal >= 6) {
                    meses = meses.concat({
                        key: "jun",
                        label: "JUN",
                        fixed: true,
                    })
                }
                if(mesInicial <= 7 && mesFinal >= 7) {
                    meses = meses.concat({
                        key: "jul",
                        label: "JUL",
                        fixed: true,
                    })
                }
                if(mesInicial <= 8 && mesFinal >= 8) {
                    meses = meses.concat({
                        key: "ago",
                        label: "AGO",
                        fixed: true,
                    })
                }
                if(mesInicial <= 9 && mesFinal >= 9) {
                    meses = meses.concat({
                        key: "set",
                        label: "SET",
                        fixed: true,
                    })
                }
                if(mesInicial <= 10 && mesFinal >= 10) {
                    meses = meses.concat({
                        key: "out",
                        label: "OUT",
                        fixed: true,
                    })
                }
                if(mesInicial <= 11 && mesFinal >= 11) {
                    meses = meses.concat({
                        key: "nov",
                        label: "NOV",
                        fixed: true,
                    })
                }
                if(mesInicial <= 12 && mesFinal >= 12) {
                    meses = meses.concat({
                        key: "dez",
                        label: "DEZ",
                        fixed: true,
                    })
                }
                meses = meses.concat({
                        key: "total",
                        label: "Total",
                        sortable: true,
                        fixed: true,
                    })
            }
            return this.columns
                .concat(meses)
                .filter(
                    (c) => c.fixed || false || this.selectedCols.includes(c.key)
                );
        },
    },
    created() {
        this.repositories = {
            relatorioViagemVeiculo: this.getConectaSusRepository(
                "transportePaciente.relatorioViagemVeiculo"
            ),
            impressao: this.getConectaSusRepository(
                "impressao.transportePaciente"
            ),
            exportacao: this.getConectaSusRepository(
                "exportacao.transportePaciente"
            ),
        };
        this.load();
    },
    data() {
        return {
            model: null,
            form: null,
            columns: [
                {
                    key: "veiculo",
                    label: "Veículo",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "municipio",
                    label: "Município - UF",
                    sortable: true,
                    fixed: true,
                },
            ],
            items: [],
            totais: [],
            veiculos: [],
            selectedCols: [],
            enums: {
                mesesAno
            },
        };
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        handlePeriodo() {
            this.model.periodo.start = null
            this.model.periodo.end = null
        },
        load() {
            this.setLoading();
            this.repositories.relatorioViagemVeiculo
                .index()
                .then(({ data }) => {
                    this.form = data.form;
                    this.model = data.model;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        getVeiculos() {
            this.setLoading();
            this.repositories.relatorioViagemVeiculo
                .getVeiculos({
                    data_inicial: moment(this.model.periodo.start).format(
                        "Y-M-D"
                    ),
                    data_final: moment(this.model.periodo.end).format("Y-M-D"),
                    status: this.model.status,
                })
                .then(({ data }) => {
                    this.form.veiculos = data;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        search() {
            this.$refs.Form.validate().then(valid => {
                if(valid) {
                    this.setLoading();
                    this.repositories.relatorioViagemVeiculo
                        .list({
                            data_inicial: moment(this.model.periodo.start).format("Y-M-D"),
                            data_final: moment(this.model.periodo.end).format("Y-M-D"),
                            veiculo: this.model.veiculo,
                            status: this.model.status,
                        })
                        .then(({ data }) => {
                            this.items = data.resultado
                            this.veiculos = data.veiculos
                            this.totais = data.totais
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                }
            })
        },
        reset() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.veiculo = null
            this.model.status = null
            this.items = []
            this.veiculos = []
            this.totais = []
        },
        print() {
            this.setLoading();
            this.repositories.impressao
                .relatorioViagemVeiculo(this.prepareDataWithColumns())
                .then(({ data, headers }) =>
                    this.openFile(data, headers["content-type"])
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        exportTo() {
            this.setLoading();
            this.repositories.exportacao
                .relatorioViagemVeiculo(this.prepareDataWithColumns())
                .then(({ data, headers }) =>
                    this.openFile(data, headers["content-type"])
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        prepareDataWithColumns() {
            const data = this.prepareData();
            data.selectedCols = this.fields.map((f) => {
                return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class,
                };
            });
            return data;
        },
        prepareData() {

            const data = {}

            data.dataInicial = moment(this.model.periodo.start).format("Y-M-D");
            data.dataFinal = moment(this.model.periodo.end).format("Y-M-D");
            data.veiculo = this.model.veiculo
            data.status = this.model.status
            data.filtroVeiculo = this.model.veiculo
                ? this.form.veiculos.find((v) => v.id == this.model.veiculo).descricao
                : null;
            data.filtroStatus = this.model.status
                ? this.form.status.find((s) => s.id == this.model.status).descricao
                : null;

            return this.camelObjectKeysToSnakeRecursive(data);
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
};
</script>
